import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'app-summary-card-content',
})
export class SummaryCardContentDirective {
  @HostBinding('class') elClass = 'summary-card-content';
}
